import { render, staticRenderFns } from "./CopyLink.vue?vue&type=template&id=b36b5054&scoped=true&"
import script from "./CopyLink.vue?vue&type=script&lang=js&"
export * from "./CopyLink.vue?vue&type=script&lang=js&"
import style0 from "./CopyLink.vue?vue&type=style&index=0&id=b36b5054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36b5054",
  null
  
)

export default component.exports